import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=b91fa0f0&scoped=true&"
import script from "./Layout2.vue?vue&type=script&lang=js&"
export * from "./Layout2.vue?vue&type=script&lang=js&"
import style0 from "./Layout2.vue?vue&type=style&index=0&id=b91fa0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91fa0f0",
  null
  
)

export default component.exports